// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/reset.css'
import 'animate.css'
import $ from 'jquery'
import 'swiper/dist/css/swiper.css';
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

// Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data:{
    width:0,//可见区域宽度
  },
  mounted () {
    this.browserRedirect();

    var _this = this;
    this.width = document.documentElement.clientWidth;
    window.onresize = function(){
      _this.width = document.documentElement.clientWidth;
      _this.changeMargin();
    };

  },
  created(){
  },
  methods:{
    changeMargin () {
      //可见区域宽度小于1024的时候，按手机端计算
      if(this.width < 460){
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/375) + "px";
        
      }else if(this.width < 640){
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/400) + "px";
        
      }else if(this.width < 900){
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/1600) + "px";
        
      }else{
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/1920) + "px";
      }
    },
    browserRedirect() {
      //判断是否是移动端
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        $("head").append("<meta content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' name='viewport' />");
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/375) + "px";
        window.onresize = function(){
          document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/375) + "px";
        } 
        $("body").css({
          'overflow':'hidden',
          'width': '100vw'
        })

      } else {
        document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/1920) + "px";
        window.onresize = function(){
          document.documentElement.style.fontSize = 100 * (document.documentElement.clientWidth/1920) + "px";
        } 
        $("head").append("<meta content='width=device-width,user-scalable=no' name='viewport'>");
      }

    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js